module.exports = __webpack_public_path__ + "static/media/magentaHeart.6084b78c.svg";